import React from "react";
import AvailableSlot  from "./availableSlot";

class AvailableSlotParent extends React.Component {
    render() {
        return <AvailableSlot />
    }
}
export default AvailableSlotParent;
